import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Table } from 'semantic-ui-react';

import { AppState } from 'services/types';
// @ts-ignore
import ResponsiveTable from 'components/ResponsiveTable';
import { selectPayrollExportsIds } from 'services/payrollExports/selectors';
import { PayrollExportId } from 'services/payrollExports/types';
import TimesheetSubmissionsTableHead from './components/TimesheetSubmissionsTableHead';
import TimesheetSubmissionsTableRow from './components/TimesheetSubmissionsTableRow';

interface ConnectedProps {
    ids?: PayrollExportId[];
}

type Props = ConnectedProps;

export class TimesheetSubmissionsTableComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { ids } = this.props;

        return (
            <React.Fragment>
                <ResponsiveTable>
                    <Table
                        sortable
                        striped
                        singleLine
                        unstackable
                        size="small"
                        selectable
                    >
                        <TimesheetSubmissionsTableHead />
                        <Table.Body>
                            {(!ids || !ids.length) && (
                                <Table.Row colSpan="5" textAlign="center">
                                    <Table.Cell
                                        colSpan="5"
                                        className="events-table-cell-padding"
                                    >
                                        There are no Timesheet Submissions.
                                    </Table.Cell>
                                </Table.Row>
                            )}
                            {ids &&
                                ids.map((id) => (
                                    <TimesheetSubmissionsTableRow
                                        key={id}
                                        id={id}
                                    />
                                ))}
                        </Table.Body>
                    </Table>
                </ResponsiveTable>
            </React.Fragment>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    ids: selectPayrollExportsIds
});

export default connect(mapStateToProps)(TimesheetSubmissionsTableComponent);
